import type { RowInfoToGetRSVP } from 'mini-common-schema/lib/schema/RowInfoToGetRSVP';

/*
 * List to store the meeting item infos required to fetch their RSVP information.
 * NOTE: When we choose to support multiple mailboxes in Mini, we can use map to store
 *       fetch list corresponding to a mailbox.
 */
const meetingItemFetchList: RowInfoToGetRSVP[] = [];

/**
 * Add an item id (with its conversationId) to the meeting id map
 * @param itemId the item id
 * @param tableViewId the tableView id
 * @param conversationId the conversation id, if in conversation view
 */
export const addToMeetingItemFetchList = (
    itemId: string,
    tableViewId: string,
    conversationId?: string
) => {
    !containsInMeetingItemFetchList(itemId) &&
        meetingItemFetchList.push({
            itemId,
            tableViewId,
            conversationId,
        });
};

/**
 * Tells whether an item is already added to the fetch list
 * @param itemId the item id to be fetched
 * @returns true if an item is already added to the fetch list, false otherwise
 */
export const containsInMeetingItemFetchList = (itemId: string): boolean =>
    meetingItemFetchList.some(rowInfo => rowInfo.itemId === itemId);

/**
 * Clears the fetch list
 */
export const clearMeetingItemFetchList = () => {
    meetingItemFetchList.length = 0;
};

/**
 * Gets the deep copied list of meeting items to be fetched
 * @return an array of RowInfo (item ids to be fetched and their conversation id) for meeting information
 */
export const getMeetingItemFetchList = (): RowInfoToGetRSVP[] =>
    JSON.parse(JSON.stringify(meetingItemFetchList));
